import React, { useMemo } from 'react'

import Skeleton from '@/components/shared/ui/Skeleton/Skeleton'

interface IPropTypes {
  count?: number
}
export default function UserPostListLoader({ count = 10 }: IPropTypes) {
  const mockPosts = useMemo(
    () => Array.from({ length: count }, (_, i) => i),
    [count]
  )

  return (
    <div className='flex flex-col gap-y-2'>
      {mockPosts.map((p) => (
        <div
          key={p}
          className='flex select-none gap-3 rounded-xl border border-gray5 bg-snow px-4 py-4 duration-150 hover:shadow'
        >
          {/* Upvote/Downvote skeleton */}
          <div className='mt-1 flex min-w-[30px] shrink-0 flex-col space-y-1'>
            <Skeleton className='h-6 w-6 rounded-md' />
            <Skeleton className='h-6 w-6 rounded-md' />
          </div>
          {/* Post content skeleton */}
          <div className='flex w-full flex-col space-y-2'>
            <div className='flex items-center justify-between'>
              <Skeleton className='h-5 w-2/3 rounded-xl' />
              <Skeleton className='h-4 w-12 rounded-xl' />
            </div>
            <Skeleton className='h-4 w-full rounded-xl' />
            <div className='flex items-center justify-between'>
              <div className='flex space-x-2'>
                <Skeleton className='h-4 w-16 rounded-xl' />
                <Skeleton className='h-4 w-16 rounded-xl' />
                <Skeleton className='h-4 w-16 rounded-xl' />
              </div>
              <Skeleton className='h-4 w-10 rounded-xl' />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
